import { useV2GetPsaProjectTicketsQuery } from "@generated";
import { Opt } from "../../types/PsaProject";

const toOpts = (d?: { id?: any; name?: string }[]): Opt[] =>
  (d ?? []).map((r) => ({ value: String(r.id), label: r.name ?? "" }));

export const usePsaProjectTickets = (
  integrationId: string,
  psaProjectId: string
) => {
  const { data, isFetching } = useV2GetPsaProjectTicketsQuery(
    { id: integrationId, projectId: psaProjectId },
    { skip: !psaProjectId }
  );
  return { tickets: toOpts(data?.data), isFetching };
};
